import { type ReactNode, useEffect } from 'react';
import { SignerRole } from 'xosign-types';
import { useTranslation } from 'react-i18next';
import useApp from '@/pages/App.context';
import useSign from '@/pages/SignLayout.context';
import LoginPassword from './Login/LoginPassword';
import LoginPIN from './Login/LoginPin';
import LoginSMS from './Login/LoginSMS';
import Representatives from './Representatives';
import Signer from './Signer';
import Viewer from './Viewer';
import styles from './Welcome.module.scss';

const Welcome = () => {
  const { t } = useTranslation(['sign']);
  const { setAppTitle } = useApp();
  const { overallLoading, signing, visitor, loginInfo } = useSign();

  useEffect(() => {
    setAppTitle(t('sign:welcome.title'));
  }, [setAppTitle, t]);

  let content: ReactNode;
  let isGuardScreen = false;

  if (overallLoading) {
    content = (
      <div className={styles.loading}>{t('sign:welcome.loadingData')}</div>
    );
  } else if (loginInfo.needed && loginInfo.loginType === 'password') {
    content = <LoginPassword />;
    isGuardScreen = true;
  } else if (loginInfo.needed && loginInfo.loginType === 'sms') {
    content = <LoginSMS />;
    isGuardScreen = true;
  } else if (loginInfo.needed && loginInfo.loginType === 'pin') {
    content = <LoginPIN />;
    isGuardScreen = true;
  } else if (!signing) {
    content = (
      <div className={styles.error}>
        {t('sign:welcome.errorLoadingSigning')}
      </div>
    );
  } else if (!visitor) {
    content = (
      <div className={styles.error}>{t('sign:welcome.errorLoadingUser')}</div>
    );
  } else if (visitor.kind === 'company') {
    content = <Representatives />;
    isGuardScreen = true;
  } else if (visitor.role === SignerRole.SIGNER) {
    content = <Signer />;
  } else if (visitor.role === SignerRole.VIEWER) {
    content = <Viewer />;
  } else {
    content = null;
  }

  return (
    <div className={styles.pane}>
      {!isGuardScreen && (
        <h1 className={styles.h1}>{t('sign:welcome.headline')}</h1>
      )}
      {content}
      {!isGuardScreen && (
        <div className={styles.footer}>{t('sign:welcome.footer')}</div>
      )}
    </div>
  );
};

export default Welcome;
